import { useGetNotesListMutation } from 'app/api/facade';

interface ShipNoteCellProps {
  mmsi?: number;
}

export const ShipNoteCell = ({ mmsi }: ShipNoteCellProps) => {
  const [, { data }] = useGetNotesListMutation({
    fixedCacheKey: 'get-notes-mutation',
  });
  const vesselNotes = data?.result?.find((note) => note.objectDefinition === `MMSI:${mmsi}`)?.notes;
  const note = vesselNotes?.[0];

  if (!note) return null;
  return <>{note.message}</>;
};
